

const initialState = {
    dogs: [],
    detail:[],
    allDogs: [],
    temperaments: [],
    filterOrder:[],
    initialTemps:[]

    
}

function rootReducer(state= initialState, action){
    switch(action.type){
        case 'GET_DOGS'://aqui puede ir sin comillas
            return { 
                ...state,
                dogs: action.payload ,
                allDogs: action.payload
            }
        case 'GET_NAME_DOGS':
            return {
               ...state,
               dogs: action.payload
            }     
        case 'FILTER_CREATED':
            const allDogs2 = state.allDogs
            const createdFilter = action.payload === 'created'
            ?allDogs2.filter(el=> el.createdInDb)
            :allDogs2.filter(el =>!el.createdInDb)
            return{
                ...state,
                dogs: action.payload === 'All'? state.allDogs:createdFilter

            }
        case 'ORDER_BY_TEMP':
            const tempDogs = state.allDogs
            const filterTemp = action.payload === 'All'
            ?tempDogs
            :tempDogs.filter(e=> e.temperaments.includes(action.payload))
            console.log(filterTemp)
            return{
                ...state,
                dogs:action.payload === 'All'? state.allDogs:filterTemp, 
            };      
        case 'ORDER_BY_NAME':
            let orderDogs = [...state.dogs]
            orderDogs = orderDogs.sort((a,b)=>{
                if(a.name<b.name){
                    return action.payload === "asc"?-1:1;
                }
                if(a.name > b.name){
                    return action.payload === "asc"? 1:-1;
                }
                return 0;
            })
                return{
                    ...state,
                    dogs: orderDogs
                }
        case 'GET_TEMPERAMENTS'://** me trae temperamentos para la creacion del dog con temps
            return{
                ...state,
                temperaments: action.payload
            }    
        case 'ORDER_WEIGHT':
            let orderWeight = [...state.dogs]
            orderWeight = orderWeight.sort((a,b)=>{
                if(a.weight_Min < b.weight_Min){
                    return action.payload === "wmax"?-1:1;
                }
                if(a.weight_Min > b.weight_Min){
                   return action.payload === "wmax"? 1:-1;
                }
                return 0;
            })
            return{
                ...state,
                dogs: orderWeight
            }
         
        case 'POST_DOGS':
            return{
                ...state,
            }  
        case 'GET_DETAILS':
            return{
                ...state,
                detail: action.payload
            }           
        default:
            return state;    
    }
}
export default rootReducer;

 /*   let sorteArr = action.payload === 'asc'?
                state.dogs.sort(function(a, b){
                    if(a.name > b.name){
                        return 1;
                    }
                    if(b.name > a.name){
                        return -1;
                    }
                    return 0;
                }):
                state.dogs.sort(function(a,b){
                    if(a.name > b.name){
                        return 1;
                    }
                    if(b.name > a.name){
                        return -1;
                    }
                    return 0; 
                }) 
            return{
                ...state,
                dogs: sorteArr
            } */

            //dogs.filter(e=> e. temperament.includes(action.payload))